<div
	class="obg-m-reality-check-snackbar-content-wrap"
	test-id="reality-check-snackbar"
	data-test-id="reality-check-snackbar"
>
	<div class="obg-m-reality-check-snackbar-content">
		<span class="ico-information-circle"></span>
		<span [innerHTML]="data.message"></span>
	</div>
	<div *ngIf="data.buttons?.length" class="obg-m-reality-check-snackbar-buttons">
		<ng-container *ngFor="let button of data.buttons">
			<a *ngIf="getButtonCounter$(button) | async as counter; else regularButtons" mat-flat-button disabled>
				{{ "reality-check.dismiss-in" | translate }} {{ counter }} {{ "general.seconds" | translate }}
			</a>
			<ng-template #regularButtons>
				<a
					mat-flat-button
					[obgRouteLink]="{ url: button.url }"
					[target]="button.target"
					(click)="onDismiss()"
					color="primary"
					test-id="reality-check-dismiss-button"
					data-test-id="reality-check-dismiss-button"
					>{{ button.text }}</a
				>
			</ng-template>
		</ng-container>
	</div>
</div>
<span *ngIf="data.dismissible" class="ico-close" (click)="onDismiss()"></span>
